import React from "react";
import Spinner from "../Spinner/spinner";
import Header from "../Header/header";


export const LoadingScreen = () => {
    const messages = [
      "Securely fetching your offers…",
      "Verifying eligibility…",
      "Analyzing lender responses…",
      "Preparing the best options for you…",
    ];
  
    const [index, setIndex] = React.useState(0);
  
    React.useEffect(() => {
      const interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % messages.length);
      }, 2500);
      return () => clearInterval(interval);
    }, []);
  
    return (
        <div className="absolute top-0 w-full max-w-[400px] mx-auto h-screen bg-white flex flex-col">
      
          {/* Fixed Header Section */}
          <div className="w-full">
            <Header />
          </div>
      
          {/* Centered Loader Section */}
          <div className="flex flex-col items-center justify-center flex-1 px-6 text-center">
      
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Processing Your Request
            </h2>
      
            {/* Rotating message */}
            <p className="text-gray-600 text-sm transition-opacity duration-500">
              {messages[index]}
            </p>
      
            {/* Green spinner */}
            <div className="mt-8">
              <div className="w-10 h-10 border-2 border-gray-200 border-t-green-600 rounded-full animate-spin"></div>
            </div>
      
          </div>
        </div>
      );
      
  };
  